<svg #symbolSvg class="footprint-version-preview-svg"></svg>
